// extracted by mini-css-extract-plugin
module.exports = {"title":"navbar_title__aPYF8","content":"navbar_content__2VL1f","navbar":"navbar_navbar__3DvWZ","backlink":"navbar_backlink__31s2y"};